import { useTranslation } from "react-i18next";
import singleMode from "hooks/filters/filterBaseSingle";
import DateTime from "utils/datetime";

export const rawItems = [
	{
		key: "today",
		value: "today",
		meta: {
			url: "today",
			value: 0,
		},
	},
	{
		key: "yesterday",
		value: "yesterday",
		meta: {
			url: "yesterday",
			value: 1,
		},
	},
	{
		key: "preyesterday",
		value: "preyesterday",
		meta: {
			url: "day-before-yesterday",
			value: 2,
		},
	},
	{
		key: "lastWeek",
		value: "lastWeek",
		meta: {
			url: "last-7-days",
			value: 7,
		},
	},
	{
		key: "lastMonth",
		value: "lastMonth",
		meta: {
			url: "last-30-days",
			value: 30,
		},
	},
	{
		key: "total",
		value: "total",
		meta: {
			url: "total",
			value: null,
		},
	},
];

export const isValid = (value) => {
	if (value === "") {
		return true;
	}
	const validValuesArray = rawItems.map((item) => item.meta.url);
	return validValuesArray.includes(value);
};

export const compute = {
	valueToApiParam: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.meta.value : null;
	},
	urlToApiParam: (value) => {
		const current = rawItems.find((item) => item.meta.url === value);
		return current ? current.meta.value : null;
	},
	valueToUrl: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.meta.url : "today";
	},
};

const useFilterPeriod = ({ initial }) => {
	const dt = new DateTime();

	const { t } = useTranslation(["filtersAndSelectors"]);

	const texts = {
		today: dt.format("DD.MM.YYYY"),
		yesterday: dt.modify("-1 day").format("DD.MM.YYYY"),
		preyesterday: dt.modify("-1 day").format("DD.MM.YYYY"),
		lastWeek: t("filtersAndSelectors:period.lastWeek"),
		lastMonth: t("filtersAndSelectors:period.lastMonth"),
		total: t("filtersAndSelectors:period.total"),
	};

	const items = rawItems.map((item) => ({
		...item,
		text: texts[item.key],
		content: texts[item.key],
	}));

	return {
		items,
		compute,
		...singleMode({ items, initial, compute }),
	};
};

export default useFilterPeriod;
